// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605040803/js/" + chunkId + "." + {"44":"b0f13ae1","225":"61399851","481":"2b9f0880","486":"66cdc458","770":"5aa88109"}[chunkId] + ".0.37144708403780147.chunk.js";
};